import { render, staticRenderFns } from "./configStockFile.vue?vue&type=template&id=319271f8&scoped=true"
import script from "./configStockFile.vue?vue&type=script&lang=js"
export * from "./configStockFile.vue?vue&type=script&lang=js"
import style0 from "./configStockFile.vue?vue&type=style&index=0&id=319271f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319271f8",
  null
  
)

export default component.exports